import React, { Component } from "react";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  notification,
  Space,
  Spin
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../styles/general.css";

import { MakeRequestAsync } from "../functions/axios";
import { POST, GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  country,
  get_all_country,
  user,
  create_user,
  update_user,
  check_tag,
  card,
  province,
  get_all_province,
  city,
  get_all_city,
  zip,
  get_all_zip
  // update_password_user
} from "../constants/routes";
import { openNotificationWithIcon } from "../functions/notification";
import { raw_menu } from "../constants/raw-list";
import {
  EmailValidation,
  PasswordValidation
} from "../functions/validateEmailPassword";
import { uploadFile } from "../functions/upload-file";
import { AiFillMinusCircle } from "react-icons/ai";
import { MdVerified } from "react-icons/md";
import { decryptSingleData } from "../functions/cryptojs";

const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Support_new extends Component {
  state = {
    visible: false,
    type: "partner",
    title: "",
    message: "",
    entity_id: this.props._id,
    pic: null,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImage = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {};

  handleSubmit = async (e) => {
    e.preventDefault();

    const { type, title, message, entity_id, pic } = this.state;

    const data = {
      type,
      title,
      message,
      entity_id,
      pic
    };

    if (title === "" || message === "") {
      return openNotificationWithIcon(
        "error",
        "You must fill title and message"
      );
    }

    this.setState({ load: true });

    let pic_url;

    if (pic !== null) {
      pic_url = await uploadFile(pic);

      if (!pic_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "An error has occured while uploading the image, please try again"
        );
      }
    }

    const request_details = {
      type: POST,
      url: service_api,
      route: "support/create-support-partner",
      data: {
        ...data,
        pic: pic === null ? null : pic_url.data.url
      },
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      console.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    });

    return setTimeout(() => window.location.reload(), 0);
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { title, message, pic, list, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          + New ticket
        </Button>
        <Drawer
          title="Add a ticket"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Retour
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Title"
                  rules={[
                    {
                      required: true,
                      role: "title"
                    }
                  ]}
                >
                  <Input
                    name="title"
                    placeholder="Title"
                    onChange={this.handleChange}
                    value={title}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Message"
                  rules={[
                    {
                      required: true,
                      role: "Message"
                    }
                  ]}
                >
                  <Input.TextArea
                    name="message"
                    rows={4}
                    placeholder="Message"
                    onChange={this.handleChange}
                    value={message}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Image"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    // multiple={true}
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImage}
                    value={pic}
                    name="pic"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Support_new;
